if (!customElements.get('films-tv')) {
  customElements.define(
    'films-tv',
    class FilmsTv extends HTMLElement {
      connectedCallback() {
        this.channels = Array.from(this.querySelectorAll('[data-channel]'));
        if (!this.channels.length) return;

        this.index = 0;
        this.osd = this.querySelector('.films-tv__osd');
        this.announcer = this.querySelector('[data-channel-announcer]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.inView = true;

        const multiple = this.channels.length > 1;
        this.channels.forEach((channel) => {
          const video = channel.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.loop = !multiple;
          if (multiple) video.addEventListener('ended', () => this.show(this.index + 1));
        });

        this.querySelector('[data-channel-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-channel-next]')?.addEventListener('click', () => this.show(this.index + 1));

        this.onBlockSelect = (event) => {
          const i = this.channels.indexOf(event.target);
          if (i !== -1) this.show(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            const video = this.channels[this.index].querySelector('video');
            if (!video) return;
            if (this.inView) this.play(video);
            else video.pause();
          });
          this.observer.observe(this);
        }

        this.show(0, { effect: false });
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.observer?.disconnect();
      }

      play(video) {
        if (this.reducedMotion || !this.inView) return;
        video.play().catch(() => {});
      }

      show(nextIndex, { effect = true } = {}) {
        const count = this.channels.length;
        const next = ((nextIndex % count) + count) % count;
        const current = this.channels[this.index];

        if (current && next !== this.index) {
          current.classList.remove('is-active');
          current.querySelector('video')?.pause();
          const oldFrame = current.querySelector('iframe');
          if (oldFrame) oldFrame.removeAttribute('src');
        }

        this.index = next;
        const channel = this.channels[next];
        channel.classList.add('is-active');

        const video = channel.querySelector('video');
        if (video) {
          video.currentTime = 0;
          this.play(video);
        }

        const frame = channel.querySelector('iframe');
        if (frame && frame.dataset.src && !frame.getAttribute('src')) {
          const sep = frame.dataset.src.includes('?') ? '&' : '?';
          frame.src = `${frame.dataset.src}${sep}autoplay=${this.reducedMotion ? 0 : 1}`;
        }

        if (count > 1) {
          const label = `CH ${String(next + 1).padStart(2, '0')}`;
          if (this.announcer) this.announcer.textContent = `Channel ${next + 1} of ${count}`;
          if (effect) this.flash(label);
        }
      }

      flash(label) {
        this.classList.remove('is-switching');
        void this.offsetWidth;
        this.classList.add('is-switching');

        if (!this.osd) return;
        this.osd.textContent = label;
        this.osd.classList.add('is-visible');
        clearTimeout(this.osdTimer);
        this.osdTimer = setTimeout(() => this.osd.classList.remove('is-visible'), 1800);
      }
    }
  );
}
